export const getUserInfo = state => state.userInfo
export const getMenus = state => state.menus
export const getAdState = state => state.isAdmin
export const getRandomStr = state => state.randomStr
export const getShowVerity = state => state.showVerity
export const isXkwAdmin = state => {
   let isAdmin = false
   let roles = state.userInfo.roles
   if (roles) {
      // SCHOOL_ADMIN("918071701", "管理员", 3, "校领导", "school"),
      // REGION_SUPPER_ADMIN("718071701", "超级管理员", 8, "信息化管理员", "region"),
      const target = roles.find(item => item.roleCode === '918071701' || item.roleCode === '718071701')
      if (target) {
         return true
      }
   }
   return isAdmin
}

export const isTest = () => {
   return process.env.NODE_ENV !== 'production'
}

// 是否是灰度用户
export const isGrayscaleUser = state => {
   return (state.userInfo.productPermissionIds || []).indexOf('YJOT') >= 0
}

// 是否有阅卷权限
export const isYJPermission = state => {
   return (state.userInfo.productPermissionIds || []).indexOf('gdejtyj') >= 0
}

// 是否是多卡（pc、第三方制卡）
export const isMultiSheet = state => {
   return (state.userInfo.productPermissionIds || []).indexOf('YJOT-MULTIPLE-SHEET') >= 0
}

// 是否跳转到新组卷制卡页面
export const isJumpNewCard = state => {
   return sessionStorage.getItem('LoginPlatform') === 'region' || !isYJPermission(state) || isGrayscaleUser(state)
}
